import React from 'react'

const Frontend = () => {
    return (
        <div className="skills_content">
            <h3 className="skills_title">Habilidades  FrontEnd</h3>

            <div className="skills_box">
                <div className="skills_group">

                    <div className="skills_data">
                        <i className="bx bx-badge-check"></i>

                        <div>
                            <h3 className="skills_name">Bootstrap</h3>
                            <span className='skills_lavel'>Intermédio</span>
                        </div>
                    </div>

                    <div className="skills_data">
                        <i className="bx bx-badge-check"></i>

                        <div>
                            <h3 className="skills_name">Sass</h3>
                            <span className='skills_lavel'>Intermédio</span>
                        </div>
                    </div>

                    <div className="skills_data">
                        <i className="bx bx-badge-check"></i>

                        <div>
                            <h3 className="skills_name">HTML5</h3>
                            <span className='skills_lavel'>Especialista</span>
                        </div>
                    </div>

                    <div className="skills_data">
                        <i className="bx bx-badge-check"></i>

                        <div>
                            <h3 className="skills_name">css</h3>
                            <span className='skills_lavel'>Especialista</span>
                        </div>
                    </div>

                    <div className="skills_data">
                        <i className="bx bx-badge-check"></i>

                        <div>
                            <h3 className="skills_name">JavaCript</h3>
                            <span className='skills_lavel'>Especialista</span>
                        </div>
                    </div>


                </div>




            </div>

        </div>
    )
}

export default Frontend